<template>
  <v-container fluid class="adaptable">
    <v-layout row class="relative-position">
      <v-flex xs12>
        <v-card-title>
          Usuarios
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :headers="columns"
          :items="clientes"
          :search="search"
          :pagination.sync="serverPagination"
          class="elevation-8"
        >
          <template v-slot:items="props">
            <tr
              :class="`theme--light cursor-pointer py-2`"
              class="pt-2"
              @click="cargarCliente(props.item)"
            >
              <td key="Usuario">
                <div class="ellipsis">
                  {{ props.item.Usuario }}
                </div>
                <!--<router-link :to="loadCliente(props.item, true)" :event="null" tabindex="-1" />-->
              </td>
              <td key="NombreCompleto">
                <div class="ellipsis">
                  {{ props.item.NombreCompleto }}
                </div>
                <!--<router-link :to="loadCliente(props.item, true)" :event="null" tabindex="-1" />-->
              </td>
              <td key="Descripcion">
                <div class="ellipsis">
                  {{ props.item.Descripcion }}
                </div>
                <!--<router-link :to="loadCliente(props.item, true)" :event="null" tabindex="-1" />-->
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            No se encuentran resultados para "{{ search }}".
          </v-alert>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-layout>
      <template>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark @click="addArea()">
              Añadir Usuario
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Usuario</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-text-field v-model="cliente.Usuario" label="Nombre de usuario*" required />
                <v-text-field
                  v-model="cliente.Password"
                  type="password"
                  label="Password*"
                  required
                />
                <v-text-field
                  v-model="cliente.NombreCompleto"
                  label="Nombre completo*"
                  required
                />
                <v-text-field v-model="cliente.Descripcion" label="Descripción" />
                <v-checkbox v-model="cliente.CambiarContrasena" label="Cambiar contraseña?" />
                <v-checkbox
                  v-model="cliente.ContrasenaNuncaCaduca"
                  label="Caduca contraseña?"
                />
                <v-checkbox v-model="cliente.Deshabilitada" label="Deshabilitada?" />
                <v-checkbox v-model="cliente.Bloqueada" label="Bloqueada?" />
                <v-checkbox v-model="cliente.Activa" label="Activa?" />
                <v-checkbox v-model="cliente.Rol" label="Es cliente?" />
                <v-combobox
                  v-model="select"
                  :items="items.map(z => z.Nombre)"
                  label="Cliente"
                  outlined
                  dense
                  required
                  @change="changeClient"
                />
                <v-combobox
                  v-if="select.length > 0"
                  v-model="selectInstalaciones"
                  :items="itemsInstalaciones.map(x => x.Nombre)"
                  label="Instalaciones"
                  outlined
                  dense
                  required
                  multiple
                />
              </v-container>
              <small>*campos obligatorios</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="red darken-1" text @click="dialog = false">
                Cancelar
              </v-btn>
              <v-btn color="green darken-1" text @click="saveDepartamento()">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Usuarios',
  data () {
    return {
      profile: this.$store.getters['getProfile'],
      serverPagination: {
        initial: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'Usuario',
        descending: true
      },
      total: 5,
      rowsPerPageOptions: [20, 50, 100, 150, 200],
      columns: [
        { text: 'Usuario', value: 'Usuario', sortable: true, align: 'left' },
        { text: 'Nombre Completo', value: 'NombreCompleto', sortable: true, align: 'left' },
        { text: 'Descripción', value: 'Descripcion', sortable: true, align: 'left' }
      ],
      dialog: false,
      clientes: [],
      isNew: false,
      cliente: {},
      search: '',
      select: [],
      items: [],
      selectInstalaciones: [],
      itemsInstalaciones: [],
      clienteSeleccionado: [],
      instalacionSeleccionadas: [],
      usuariosAcces: {}
    }
  },
  mounted () {
    this.getClients()
    this.getAllClientes()
  },
  methods: {
    getClients () {
      this.axios
        .get(`${this.$apiUrl('usuarios')}`, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(({ data }) => {
          this.clientes = []
          for (let z = 0; z < data.length; z++) {
            this.clientes.push(data[z])
          }
        })
    },
    cargarCliente (props) {
      this.isNew = false
      this.dialog = true
      this.axios
        .get(`${this.$apiUrl('usuarios')}?usuario=${props.Usuario}`, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(({ data }) => {
          this.cliente = data
        })
      if (props.Rol) {
        this.axios
          .get(`${this.$apiUrl('usuariosacces')}?usuario=${props.Usuario}`, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(({ data }) => {
            this.select = []
            this.selectInstalaciones = []
            this.clienteSeleccionado = []
            this.select.push((this.items.find(item => item.Codigo === data[0].CodigoCliente).Nombre))
            this.clienteSeleccionado.push((this.items.find(item => item.Codigo === data[0].CodigoCliente)))
            this.getAllInstalaciones()
            console.log(data)
            if (data[0].CodigoInstalacion > 0) {
              this.getInstalaciones(data)
            }
          })
      }
    },
    addArea () {
      this.isNew = true
      this.dialog = true
      this.cliente.Usuario = ''
      this.cliente.Password = ''
      this.cliente.NombreCompleto = ''
      this.cliente.Descripcion = ''
      this.cliente.CambiarContrasena = false
      this.cliente.ContrasenaNuncaCaduca = false
      this.cliente.Dehabilitada = false
      this.cliente.Bloqueada = false
      this.cliente.Activo = false
      this.cliente.Rol = false
      this.usuariosAcces.Usuario = ''
      this.usuariosAcces.CodigoCliente = ''
      this.usuariosAcces.CodigoInstalacion = ''
      this.select = []
      this.selectInstalaciones = []
      this.itemsInstalaciones = []
      this.clienteSeleccionado = []
      this.instalacionSeleccionadas = []
      this.usuariosAcces = {}
    },
    saveDepartamento () {
      this.instalacionSeleccionadas = []
      for (let z = 0; z < this.selectInstalaciones.length; z++) {
        this.instalacionSeleccionadas.push(this.itemsInstalaciones.find(f => f.Nombre === this.selectInstalaciones[z]))
      }
      if (this.isNew === true) {
        this.axios
          .post(`${this.$apiUrl('usuarios')}?usuario=${this.cliente}`, this.cliente, {
            headers: { 'Content-Type': 'application/json' }
          })
          .then(response => {
            if (response.status === 201) {
              this.pushUsuariosAcces()
            }
          })
      } else {
        this.axios
          .put(`${this.$apiUrl('usuarios')}?id=${this.cliente.Usuario}`, this.cliente, {
            headers: { 'Content-Type': 'application/json' }
          })
          .then(response => {
            if (response.status === 204) {
              this.usuariosAcces.Usuario = this.cliente.Usuario
              this.usuariosAcces.CodigoCliente = this.clienteSeleccionado.map(z => z.Codigo)[0]
              if (this.instalacionSeleccionadas.length <= 0 || this.instalacionSeleccionadas[0] === undefined) {
                var instalacionDefault = []
                var objDefault = {}
                objDefault.Instalacion = 0
                instalacionDefault.push(0)
                this.usuariosAcces.CodigoInstalacion = instalacionDefault
              } else {
                var instalaciones = []
                for (var z = 0; z < this.instalacionSeleccionadas.length; z++) {
                  var obj = {}
                  obj.Instalacion = this.instalacionSeleccionadas[z].Instalacion
                  instalaciones.push(this.instalacionSeleccionadas[z].Instalacion)
                }
                this.usuariosAcces.CodigoInstalacion = instalaciones
              }
              this.axios
                .put(`${this.$apiUrl('usuariosacces')}?usuariosacces=${this.usuariosAcces}`, this.usuariosAcces, {
                  headers: { 'Content-Type': 'application/json' }
                })
                .then(response => {
                  if (response.status === 204) {
                    this.$notify({ message: 'Usuario actualizado correctamente' })
                    this.dialog = false
                    this.getClients()
                  }
                })
            }
          })
      }
    },
    async getInstalaciones (data) {
      for (let c = 0; c < data.length; c++) {
        await this.axios
          .get(`${this.$apiUrl('instalacionEspecifica')}?cliente=${data[c].CodigoCliente}&instalacion=${data[c].CodigoInstalacion}`, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then(({ data }) => {
            this.selectInstalaciones.push(data.Nombre)
          })
      }
    },
    async pushUsuariosAcces () {
      this.usuariosAcces.Usuario = this.cliente.Usuario
      this.usuariosAcces.CodigoCliente = this.clienteSeleccionado.map(z => z.Codigo)[0]
      if (this.instalacionSeleccionadas.length <= 0 || this.instalacionSeleccionadas[0] === undefined) {
        var instalacionDefault = []
        var objDefault = {}
        objDefault.Instalacion = 0
        instalacionDefault.push(0)
        this.usuariosAcces.CodigoInstalacion = instalacionDefault
      } else {
        var instalaciones = []
        for (var z = 0; z < this.instalacionSeleccionadas.length; z++) {
          var obj = {}
          obj.Instalacion = this.instalacionSeleccionadas[z].Instalacion
          instalaciones.push(this.instalacionSeleccionadas[z].Instalacion)
        }
        this.usuariosAcces.CodigoInstalacion = instalaciones
      }
      await this.axios
        .post(`${this.$apiUrl('usuariosacces')}?usuariosacces=${this.usuariosAcces}`, this.usuariosAcces, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({ message: 'Usuario creado correctamente' })
            this.dialog = false
            this.getClients()
          }
        })
    },
    getAllClientes () {
      this.axios
        .get(`${this.$apiUrl('cliente')}`, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(({ data }) => {
          for (let z = 0; z < data.length; z++) {
            this.items.push(data[z])
          }
        })
    },
    getAllInstalaciones () {
      this.axios
        .get(`${this.$apiUrl('instalacion')}?cliente=${this.clienteSeleccionado.map(z => z.Codigo)}`, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(({ data }) => {
          for (let z = 0; z < data.length; z++) {
            this.itemsInstalaciones.push(data[z])
          }
        })
    },
    getColorClient (cliente) {
      let color = ''
      if (cliente.Estado === 'I') {
        color = 'red'
      } else if (cliente.Estado === 'A') {
        color = 'light-green'
      }
      return color
    },
    changeClient () {
      this.selectInstalaciones = []
      this.itemsInstalaciones = []
      this.clienteSeleccionado = []
      this.clienteSeleccionado.push(this.items.find(item => item.Nombre === this.select))
      this.getAllInstalaciones()
    }
  }
}
</script>

<style>
.adaptTable {
  margin-top: -9%;
  padding-right: 0%;
  padding-left: 0%;
}
</style>
